<template>
  <div v-loading="loading" class="rj-page-card">
    <div class="rj-page-card__title">
      合同基本信息
    </div>
    <div class="rj-page-card__content">
      <el-form ref="form" :model="form" :rules="rules" class="baseInfoForm">
        <div class="rj-row">
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单日期：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.createTime }}
              </div>
            </div>
          </div>
          <contract-number ref="contractNumber" v-model="form" />
          <supply-unit ref="supplyUnit" v-model="form" required @changesupply="changeSupply" />
          <ordering-unit v-model="form" required :is-select="(isDirectOrder || isSaleBorrowing)" :enable-change="enableChangeorderingUnit" @changeOrderUnit="changeOrderUnit" />
          <end-customer v-model="form" required @changeEndUnit="changeEndUnit" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                订单分类：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.contractType }}
              </div>
            </div>
          </div>
          <tax-type v-model="form" required @changeTaxType="changeTaxType" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                净销售额：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="netSales">
                  <el-input v-model="form.netSales" placeholder="请输入净销售额" />
                </el-form-item>
                <!--{{ form.netSales }}-->
              </div>
            </div>
          </div>
          <div v-if="form.extContractData!=null" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                框架协议编码：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.extContractData.frameworkAgreementCode==null?"":form.extContractData.frameworkAgreementCode }}
              </div>
            </div>
          </div>
          <div v-if="form.extContractData!=null" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                框架协议名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.extContractData.frameworkAgreementName==null?"":form.extContractData.frameworkAgreementName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                现销或赊销：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="salesType">
                  <el-radio-group v-model="form.salesType">
                    <el-radio v-for="(type,index) in salesType" :key="index" :label="type.code" :disabled="form.manufactureRefurbished">
                      {{ type.name }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <account-period v-model="form" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否测试样机订单：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="isTestProject">
                  <el-radio-group v-model="form.isTestProject">
                    <el-radio v-for="(type,index) in EmbeddedSoftware" :key="index" :label="type.code">
                      {{ type.name }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                付款方式：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="paymentMethodName">
                  <el-select v-model="form.paymentMethodName" placeholder="请选择付款方式">
                    <el-option v-for="item in paymentMethod" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
          <order-type ref="orderType" v-model="form" required />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                发货方式<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="shipType">
                  <el-radio-group v-model="form.shipType">
                    <el-radio v-for="(type,index) in shipTypeList" :key="index" :disabled="!(isDirectOrder || isSaleBorrowing)" :label="type.code">
                      {{ type.name }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </div>
          <pre-sale ref="preSale" v-model="form" required />
          <export-sale ref="exportSale" v-model="form" required />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                部门：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.departmentName }}
              </div>
            </div>
          </div>
          <region-auto ref="regionAuto" v-model="form" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目代码(CRM编号)：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.opportunityCode }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                项目名称：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="projectName">
                  <el-input v-model="form.projectName" placeholder="请输入项目名称" />
                </el-form-item>
              </div>
            </div>
          </div>
          <region-business ref="regionBusiness" v-model="form" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                首级集成商名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.integratorName || '无' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                首级集成商类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.integratorType || '无' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                计量集成商名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.metrologyIntegratorName || '无' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                计量集成商类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.metrologyIntegratorType || '无' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                末级集成商名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.finalIntegratorsName || '无' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                末级集成商类型：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.finalIntegratorsType || '无' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                A类产品服务商：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.productServiceProviderA || '无' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                B类产品服务商：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.productServiceProviderB || '无' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                C类产品服务商：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.productServiceProviderC || '无' }}
              </div>
            </div>
          </div>
          <div v-if="form.manufactureRefurbished" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否官翻机：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.manufactureRefurbished ?'是':'否' }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                服务主体编码：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.serviceSubjectCode }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                服务主体名称：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.serviceSubjectName }}
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                计量计点：
              </div>
              <div class="rj-baseinfo__item">
                {{ $store.getters['enumeration/getmeteringPoint'](form.meteringPoint) }}
              </div>
            </div>
          </div>
          <market v-if="form.contractType" ref="market" v-model="form" />
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                借条单号：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="borrowingOrderNumber">
                  <el-input v-model="form.borrowingOrderNumber" placeholder="请输入借条单号" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                CRM客户编码：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="crmAccountCode">
                  <el-input v-model="form.crmAccountCode" placeholder="请输入CRM客户编码" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                特价标志：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="isSpecialPrice">
                  <el-checkbox v-model="form.isSpecialPrice" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                齐套通知打款邮箱<span v-if="!(isDirectOrder || isSaleBorrowing)" class="required">*</span> ：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="setNoticeMail">
                  <el-input v-model="form.setNoticeMail" placeholder="请输入齐套通知打款邮箱" :readonly="!(this.email?false:true||isDirectOrder || isSaleBorrowing )" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                授权邮箱：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="authorizationEmail">
                  <el-input v-model="form.authorizationEmail" placeholder="请输入授权邮箱" />
                </el-form-item>
              </div>
            </div>
          </div>
          <div v-if="isSaleBorrowing" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                审批借用天数：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.approveBorrowDays }}
              </div>
            </div>
          </div>
          <div v-if="orderUnitDiscount" class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                福建/上海/香港通讯下单折扣：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item prop="paymentMethodName">
                  <el-select v-model="form.communicationOrderDiscount" placeholder="福建/上海/香港通讯下单折扣">
                    <el-option v-for="(value, key) in shanghaiHongkongDiscount" :key="key" :label="value" :value="value" />
                  </el-select>
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
        <div class="rj-row">
          <payment-bank ref="bank" v-model="form" :contract-num="contractNum" />
          <!--          <rebate-amount v-model="form" ref="rebateAmount" />-->
          <div class="rj-col-1">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                是否使用返利<span class="required">*</span>：
              </div>
              <div class="rj-baseinfo__item">
                <el-form-item style="display: inline-block">
                  <el-radio-group v-model="form.isRebate" :disabled="true">
                    <el-radio :label="true">
                      是
                    </el-radio>
                    <el-radio :label="false">
                      否
                    </el-radio>
                  </el-radio-group>
                </el-form-item>
                <template v-if="form.isRebate">
                  <span> 使用返利： {{ form.rebateAmount }} </span>
                  <span style="margin-left: 20px"> 返利可用余额： {{ form.allowUsedFL }} </span>
                </template>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo">
              <div class="rj-baseinfo__label">
                已分配金额/比例：
              </div>
              <div class="rj-baseinfo__item">
                {{ form.assignAll }}元 <template v-if="form.contractSum&&form.assignAll">
                  / {{ Number(form.assignAll*100/form.actualSettlementAmount).toFixed(2) }}%
                </template>
              </div>
            </div>
          </div>
          <div class="rj-col-3">
            <div class="rj-baseinfo" style="color:red">
              <div class="rj-baseinfo__label">
                预付款金额/比例：
              </div>
              <div class="rj-baseinfo__item">
                {{ baseData.advanceCharge }}元/{{ baseData.prepaymentRatioNum }}%
              </div>
            </div>
          </div>
          <div class="rj-col-1" style="margin:10px 0">
            <div style="font-size: 13px;color: #606266;">
              区域商务专员意见:
            </div>
            <div v-if="form.regionBusinessCommissionerOpinion " style="font-size: 13px;color: #606266;margin-top: 4px">
              {{ form.regionBusinessCommissionerOpinion }}
            </div>
            <div v-else style="font-size: 13px;color: #606266;margin-top: 4px">
              无
            </div>
          </div>
          <div class="rj-col-1" style="margin:10px 0">
            <div style="font-size: 13px;color: #606266;">
              合作情况分量说明:
            </div>
            <div v-if="form.projectDocAndProrataNote " style="font-size: 13px;color: #606266;margin-top: 4px">
              {{ form.projectDocAndProrataNote }}
            </div>
            <div v-else style="font-size: 13px;color: #606266;margin-top: 4px">
              无
            </div>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="additionalTerms" label="补充条款:">
              <el-input v-model.trim="form.additionalTerms" type="textarea" :rows="3" placeholder="请输入补充条款" maxlength="200" show-word-limit />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="serviceTerms" label="服务条款:">
              <el-input v-model.trim="form.serviceTerms" type="textarea" :rows="3" placeholder="请输入服务条款" maxlength="200" show-word-limit />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="receiptArrivalAcceptanceRequirements" label="收货回执及到货验收要求:">
              <el-input v-model.trim="form.receiptArrivalAcceptanceRequirements" type="textarea" :rows="3" placeholder="请输入收货回执及到货验收要求" maxlength="200" show-word-limit />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="remarks" label="备注说明:">
              <el-input v-model.trim="form.remarks" type="textarea" :rows="3" placeholder="请输入备注说明" maxlength="200" show-word-limit />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="deliverRemark" label="发货备注说明:">
              <el-input v-model.trim="form.deliverRemark" type="textarea" :rows="3" placeholder="请输入发货备注说明" maxlength="200" show-word-limit />
            </el-form-item>
          </div>
          <div class="rj-col-1">
            <el-form-item prop="invoiceRemark" label="开票备注说明:">
              <el-input v-model.trim="form.invoiceRemark" type="textarea" :rows="3" placeholder="请输入开票备注说明" maxlength="200" show-word-limit />
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script type="es6">
import contractNumber from '../../../contractCommonInput/contractNumber';
import supplyUnit from '../../../contractCommonInput/supplyUnit';
import orderingUnit from '../../../contractCommonInput/orderingUnit';
import EndCustomer from '../../../contractCommonInput/EndCustomer';
import baseInfoMixin from '../../createContract/baseInfoMixin';
import { mapState } from 'vuex';
// import { paymentRatioCheck } from '@/API';
// import eventBus from '../../../../libs/eventBus';
const orderType = () => import('../../../contractCommonInput/orderType');
const accountPeriod = () => import('../../../contractCommonInput/accountPeriod');
const preSale = () => import('../../../contractCommonInput/preSale');
const exportSale = () => import('../../../contractCommonInput/exportSale');
const regionAuto = () => import('../../../contractCommonInput/regionAuto');
const regionBusiness = () => import('../../../contractCommonInput/regionBusiness');
const market = () => import('../../../contractCommonInput/market');
const paymentBank = () => import('../../../contractCommonInput/paymentBank');
const taxType = () => import('../../../contractCommonInput/taxType');
// const rebateAmount = () => import('../../../contractCommonInput/rebateAmount');
export default {
  mixins: [baseInfoMixin],
  data () {
    var verifyEmail = (rule, value, callback) => {
      if (this.form.contractType === 'SMB分销下单' || this.form.contractType === '服务商分销下单' || this.isDirectOrder || this.isSaleBorrowing) {
        callback();
      } else {
        if (value === '') {
          callback(new Error('请输入齐套通知打款邮箱'));
        } else {
          callback();
        }
      }
    };
    var validateEmailAuthorization = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9]+[_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[.|-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,4}$/;
      if (!value) {
        callback();
      } else {
        if (this.form.authorizationEmail && this.form.authorizationEmail.length > 100) {
          callback(new Error('输入字符不能超过100'));
        } else if (!mailReg.test(value)) {
          callback(new Error('请输入正确的邮箱格式'));
        } else {
          callback();
        }
      }
    };
    var shipTypeing = (rule, value, callback) => {
      if (value !== 1 && value !== 2) {
        callback(new Error('请选择发货方式!'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      paymentMethod: [ {
        value: '立即',
        label: '立即付款'
      }],
      // advanceCharge: '',
      // prepaymentRatioNum: '',
      rules: {
        customerContractNum: [
          { required: true, message: '请输入客户合同编号', trigger: 'blur' }
        ],
        shipType: [
          { validator: shipTypeing, trigger: 'change' }
        ],
        // crmAccountCode: [
        //   { required: true, message: '请输入CCCCCC', trigger: 'blur' }
        // ],
        projectName: [
          { required: true, message: '请输入项目名称', trigger: 'blur' }
        ],
        supplyUnitId: [
          { required: true, message: '请选择供货单位', trigger: 'change' }
        ],
        orderUnitCode: [
          { required: true, message: '请选择订货单位', trigger: 'change' }
        ],
        finalCustomer: [
          { required: true, message: '请选择最终客户', trigger: 'change' }
        ],
        contractType: [
          { required: true, message: '请选择订单分类', trigger: 'change' }
        ],
        currencyId: [
          { required: true, message: '请选择币种', trigger: 'change' }
        ],
        preSalesCode: [
          { required: true, message: '请选择售前', trigger: 'change' }
        ],
        salesManCode: [
          { required: true, message: '请选择外销', trigger: 'change' }
        ],
        setNoticeMail: [
          // { required: true, pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/, message: '请输入正确的齐套通知打款邮箱', trigger: 'blur' }
          { validator: verifyEmail, trigger: 'blur' }
        ],
        saleTypeCode: [
          { required: true, message: '订单类型不能为空', trigger: 'change' }
        ],
        authorizationEmail: [
          { validator: validateEmailAuthorization, trigger: 'change' }
        ],
        regionBusinessCommissionerId: [{ required: true, message: '请选择区域商务专员', trigger: 'change' }]
      }
    };
  },
  model: {
    prop: 'form',
    event: 'change'
  },
  props: {
    form: {
      type: Object,
      default: () => { return {}; }
    },
    baseData: {
      type: Object,
      default: () => { return {}; }
    },
    contractNum: {
      type: [String, Number],
      default: () => { return ''; }
    },
    email: {
      type: [String, Object],
      default: () => { return ''; }
    }

  },
  components: {
    contractNumber,
    supplyUnit,
    orderingUnit,
    EndCustomer,
    orderType,
    accountPeriod,
    preSale,
    exportSale,
    regionAuto,
    regionBusiness,
    market,
    paymentBank,
    taxType
    // rebateAmount
  },
  computed: {
    ...mapState({
      moneyType: state => state.enumeration.moneyType,
      salesType: state => state.enumeration.salesType,
      // paymentMethod: state => state.enumeration.paymentMethod,
      shipTypeList: state => state.enumeration.shipType,
      EmbeddedSoftware: state => state.enumeration.EmbeddedSoftware,
      shanghaiHongkongDiscount: state => state.enumeration.shanghaiHongkongDiscount
    }),
    orderUnitDiscount () {
      let flag = false;
      if (this.form.orderUnit === '上海锐山网络有限公司' ||
      this.form.orderUnit === '上海爱伟迅数码科技有限公司' ||
      this.form.orderUnit === '星网锐捷（香港）有限公司' ||
      this.form.orderUnit === 'Ruijie Networks Communication Technology Industry and Trade Co., Ltd' ||
      this.form.orderUnit === 'Ruijie Malaysia Sdn. Bhd.' ||
      this.form.orderUnit === '福建省电子器材有限公司'
      ) {
        flag = true;
      }
      return flag;
    },
    enableChangeorderingUnit () {
      if (this.form.distributorParticipate || this.form.integratorParticipate) {
        return false;
      } else if (this.form.showNewContract) {
        return true;
      }
      return false;
    },
    // 是否是直签下单
    isDirectOrder () {
      if ((this.form.integratorParticipate === null || this.form.integratorParticipate === false) && (this.form.distributorParticipate === null || this.form.distributorParticipate === false)) {
        return true;
      }
      return false;
    },
    // 是否是销售借用下单
    isSaleBorrowing () {
      if (this.form.contractType === '销售借用下单') {
        return true;
      }
      return false;
    }
  },
  methods: {
    // 获取预付款金额比例接口

    setInitData () {
      this.$refs.supplyUnit.initData();
      if (this.$refs.exportSale) {
        this.$refs.exportSale.initData();
      }
      if (this.$refs.orderType) {
        this.$refs.orderType.initContratOrderType();
      }
      if (this.$refs.integrator) {
        this.$refs.integrator.initData();
      }
      if (this.$refs.market) {
        this.$refs.market.initData();
      }
      if (this.$refs.preSale) {
        this.$refs.preSale.initData();
      }
      if (this.$refs.regionAuto) {
        this.$refs.regionAuto.initData();
      }
      if (this.$refs.regionBusiness) {
        this.$refs.regionBusiness.initData();
      }
      if (this.$refs.bank) {
        this.$refs.bank.initData();
      }
    }
  },
  mounted () {
  }
};
</script>
<style lang="scss">
  .baseInfoForm {
    .el-form-item--mini.el-form-item {
      margin-bottom: 0;
    }
  }
</style>
<style lang="scss">
  .baseInfoForm{
    .el-form-item__error{
      position: relative;
    }
  }
  .required{
    color: red;
    margin-left: 3px;
  }
</style>
